import { ScrollTrigger } from "gsap/all";

export function render({ scroller }) {
  const height = document.querySelector(".c-header").offsetHeight;
  const targets = Array.from(document.querySelectorAll(".c-menu__icon"));

  targets.forEach((el) => {
    el.addEventListener("click", () => {
      const link = el.getAttribute("href");
      scroller.scrollTo(link, { offset: (window.innerWidth < 1024) ? - height : -125 });
    });
  });
}
